<script>
  import Pattern from "./Pattern.svelte";

  /**
   * The name of the pattern to be rendered.
   * It should match one of the keys in the PATTERN_NAMES object.
   * @type {keyof typeof import("./Pattern.svelte").PATTERN_NAMES}
   */
  export let name;

  let containerClass;
  export { containerClass as class };

  let width;
</script>

<!-- use pattern as background -->
<div class="relative z-0 {containerClass}" bind:clientWidth={width} {...$$restProps}>
  <!-- content -->
  <div class="relative">
    <slot />
  </div>

  <!-- pattern background -->
  {#if name}
    <div class="absolute bottom-0 left-0 -z-10">
      <Pattern {name} class="h-auto" opacity="0.3" {width} />
    </div>
  {/if}
</div>
